import { GlobalStyle } from '@trevor/ui-components';

export default GlobalStyle;
